module.exports = __webpack_public_path__ + "img/back-left.28f9095b.svg";